var CurrentUser = require("lib/account/CurrentUser");
var DemoAccountSwitcher = require("lib/account/DemoAccountSwitcher");

var TeacherOnboarding = {
	STEPS: {
		"select-standards": {
			title: "Choose Your Standards",
			index: 0,
			learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/115001165471",
			doAction: () => { $wr.redirect("/settings/standards") },
			imgPath: "standards"
		},
		"select-school": {
			title: "Select Your School",
			index: 1,
			learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/115001718452",
			doAction: () => { $wr.redirect("/contests?show_school_info_modal=true") },
			imgPath: "school"
		},
		"add-students": {
			title: "Add Your Students",
			index: 2,
			learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/115001333171",
			doAction: () => { 
				TeacherOnboarding.checkLocation("roster", "Add Your Students", "Click on 'Add a Student' and select an adding method.");
				$wr.redirect("/roster?addNewStudentsButton=true") 
			},
			imgPath: "students"
		},
		"student-writing": {
			title: "Do Sample Assignment",
			index: 3,
			learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/360027572111",
			doAction: () => {
				var embeds = "student_list.students,student.password";
				CurrentUser.api().getStudentLists({ embed: embeds }, $wr.apiHandler((response) => {
					var students = _.flatten(_.pluck(response.student_lists, "students"));
					var demoStudent = _.findWhere(students, { demo_for_teacher: true });
					if (demoStudent) {
						DemoAccountSwitcher.switchToStudent(demoStudent);
					} else {
						if (students.length == 0) {
							window.wrNotifications.triggerDropDownNotification({
								title: "No demo account available",
								text: "Add at least one student account first...", icon: "alt" }, 10000);
						} else {
							window.wrNotifications.triggerDropDownNotification({
								title: "No demo account available",
								text: "You can do a sample assigment by using one of your students' account...", icon: "alt" }, 10000);
						}
					}
				}));
			},
			imgPath: "demo"
		},
		"view-data": {
			title: "View Writing Data",
			index: 4,
			learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/360000607532",
			doAction: () => { 
				$wr.redirect("/data");
				$(window.document).trigger("onboarding-trigger-view-data");
			},
			imgPath: "dashboard"
		},
		"complete-quizzes": {
			title: "Complete Quizzes",
			index: 5,
			imgPath: "quizzes"
		},
		"customize-assignments": {
			title: "Set Up Goals",
			index: 6,
			learnLink: "https://whooosreading.zendesk.com/hc/en-us/articles/360024761351",
			doAction: () => { 
				$wr.redirect("/roster/goals")
				$(window.document).trigger("onboarding-trigger-customize-assignments")
			},
			imgPath: "assignment"
		},
		"autograder-demo": {
			title: "Try Our Autograder",
			index: 3,
			doAction: () => {
				var url = `${window.location.pathname}?autograderDemo=show`
				$wr.redirect(url)
			},
			imgPath: "demo"
		},
	},

	getData(key) {
		return TeacherOnboarding.STEPS[key];
	},

	getTitle(key) {
		var step = TeacherOnboarding.getData(key);
		if (step) { return step.title; }
	},
	getIndex(key) {
		var step = TeacherOnboarding.getData(key);
		if (step) { return step.index; }
	},
	getLearnLink(key) {
		var step = TeacherOnboarding.getData(key);
		if (step) { return step.learnLink; }
	},
	doIt(key) {
		var step = TeacherOnboarding.getData(key);
		if (step) { return step.doAction() }
	},
	getImgPath(key) {
		var step = TeacherOnboarding.getData(key);
		if (step) { return step.imgPath; }
	},
	checkLocation(target, title, message) {
		var loc = document.URL;
		if (loc.indexOf(target) > -1) {
			window.wrNotifications.triggerDropDownNotification({
					title: title, text: message, icon: "question-sign" });
		}
	},
	getOrderedKeys() {
		if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) { 
			return ["select-standards", "select-school", "add-students", "autograder-demo", "customize-assignments"];
		} else {
			return ["select-standards", "select-school", "add-students", "student-writing", "view-data", "customize-assignments"];
		}
		// returns all keys in order
	}
}

module.exports = TeacherOnboarding;



// WEBPACK FOOTER //
// ./modules/lib/account/TeacherOnboarding.js